import { LifecycleState as E } from "./usePageLifecycle.enums.mjs";
const r = ["focus", "blur", "visibilitychange", "freeze", "resume", "pageshow", "pagehide"], T = [
  // Обычный процесс выгрузки
  [E.ACTIVE, E.PASSIVE, E.HIDDEN, E.TERMINATED],
  // Активная страница переходит в замороженную или выгружающаяся страница попадает в bfcache.
  [E.ACTIVE, E.PASSIVE, E.HIDDEN, E.FROZEN],
  // Скрытая страница снова становится активной.
  [E.HIDDEN, E.PASSIVE, E.ACTIVE],
  // Замороженная страница возобновляется
  [E.FROZEN, E.HIDDEN],
  // Замороженная (bfcached) страница, на которую был выполнен возврат.
  [E.FROZEN, E.ACTIVE],
  [E.FROZEN, E.PASSIVE]
].map((I) => I.reduce((e, S, A) => (e[S] = A, e), {}));
export {
  T as LEGAL_STATE_TRANSITIONS,
  r as LIFECYCLE_EVENTS
};
//# sourceMappingURL=usePageLifecycle.consts.mjs.map
